import { useContext } from "react";
import { SessionContext } from "./useSession";

const usePaths = () => {
  const session = useContext(SessionContext);
  let clientCode: string | null = null;
  if (session.current != null) {
    if (session.current.credential != null) {
      clientCode = session.current.credential.clientCode;
    }
  }

  const pathWithRoot = (path: string) => {
    if (clientCode == null) {
      return path;
    }
    return `/${clientCode.toLowerCase()}${path}`;
  }

  const paths = {
    home: pathWithRoot("/home"),
    tenants: "/tenants",
    logout: "/logout",
    close: "/close",
    search: pathWithRoot("/search"),
    workflow: (productCode: string) => {
      return pathWithRoot(`/workflow/${productCode}`);
    },
    booking: (bookingId: string | number) => {
      if (bookingId == ":bookingId") {
        return `${paths.bookings}/:bookingId`;
      }
      const bookingId64 = btoa(`booking:${bookingId}`);
      return `${paths.bookings}/${bookingId64}`;
    },
    bookings: pathWithRoot("/bookings"),
    bookingCreate: pathWithRoot("/new-booking"),
    locations: pathWithRoot("/locations"),
    expressCheckOut: pathWithRoot("/express-check-out"),
    reports: pathWithRoot("/reports"),
    reportsV2: pathWithRoot("/reports-v2"),
    insights: (pageId: string) => {
      return pathWithRoot(`/insights/${pageId}`);
    },
    kmos: pathWithRoot("/kmos"),
    reportView: (reportId: string) => {
      return `${paths.reports}/view/${reportId}`
    },
    reportEdit: (reportId: string) => {
      return `${paths.reports}/edit/${reportId}`
    },
    reportsWithCategory: (category: string) => {
      return `${paths.reports}/cat/${category}`
    },
    reportsV2WithCategory: (category: string) => {
      return `${paths.reportsV2}/cat/${category}`
    },
    reportV2View: (reportId: string, noReturn: boolean) => {
      return `${paths.reportsV2}/view/${reportId}/${noReturn ? '1' : '0'}`
    },
    complaints: pathWithRoot('/complaints'),
    vehicleManager: pathWithRoot('/vehicles'),
    vehicleManagerMove: pathWithRoot('/vehicles/move'),
    keyManager: pathWithRoot('/keys'),
    keyManagerMove: pathWithRoot('/keys/move'),
    keyManagerViewAudit: (auditid: string | number) => {
      return pathWithRoot(`/key-audit/view/${auditid}`)
    },
    vehicleManagerViewAudit: (auditid: string | number) => {
      return pathWithRoot(`/vehicle-audit/view/${auditid}`)
    },
    dynamicAllocation: pathWithRoot('/dynamic-allocation'),
    settings: pathWithRoot(`/settings`),
    devices: pathWithRoot(`/devices`),
    admin: '/admin',
    reportIssue: pathWithRoot('/report-issue'),
    telematics: pathWithRoot('/telematics'),
    busWalkarounds: pathWithRoot('/bus-walkarounds'),
    driverShiftTracker: pathWithRoot('/driver-availability'),
    pair: pathWithRoot('/pair'),
    scanning: pathWithRoot('/scanning')
  };

  return paths;
}

export default usePaths
